class MainGroupModel {
    id?: number;
    count?: number;
    mainGroupId?: number;
    name?: string;
}
export default MainGroupModel;
